import React from "react";
import style from "./Footer.module.css"
const Footer = () => {
    return (
        <footer className={style.footer}>
            <div className={style.text}>
                <a className={style.link} href="https://www.jamesmaino.com/">
                © 2022-present James Maino</a>
            </div>
        </footer>
    )
}

export default Footer
